document.addEventListener('DOMContentLoaded', () => {
	const videoWrappers = document.querySelectorAll('.grid-media__video-wrapper');

	if (!videoWrappers.length) {
		return;
	}

	videoWrappers.forEach((wrapper) => {
		const video = wrapper.querySelector('video');

		if (!video) {
			return;
		}

		const playVideo = () => {
			wrapper.classList.add('playing');
			wrapper.setAttribute('aria-label', 'Pause video');

			video.setAttribute('controls', 'controls');

			const playPromise = video.play();

			if (playPromise !== undefined) {
				playPromise.catch(() => {
					wrapper.classList.remove('playing');
					wrapper.setAttribute('aria-label', 'Play video');
					video.removeAttribute('controls');
				});
			}
		};

		const pauseVideo = () => {
			video.pause();
			wrapper.classList.remove('playing');
			wrapper.setAttribute('aria-label', 'Play video');
			video.removeAttribute('controls');
		};

		const toggleVideo = () => {
			if (video.paused) {
				playVideo();
			} else {
				pauseVideo();
			}
		};

		wrapper.addEventListener('click', (event) => {
			if (event.target.closest('video') && !video.paused) {
				return;
			}

			toggleVideo();
		});

		wrapper.addEventListener('keydown', (event) => {
			if (event.key !== 'Enter' && event.key !== ' ') {
				return;
			}

			event.preventDefault();
			toggleVideo();
		});

		video.addEventListener('pause', () => {
			wrapper.classList.remove('playing');
			wrapper.setAttribute('aria-label', 'Play video');
			video.removeAttribute('controls');
		});

		video.addEventListener('ended', () => {
			wrapper.classList.remove('playing');
			wrapper.setAttribute('aria-label', 'Play video');
			video.removeAttribute('controls');
		});
	});
});